import urljoin from 'url-join';
import { THETA_RESOURCE_ENDPOINT } from '@vestingSafe/src/constants';

/**
 * Parse input object into query string. Ignore completely parameters except string, number and/or boolean.
 * If the final string is non-empty,`?` will be prepended to the output.
 */
export function formatQueryString(input) {
  const params = [];

  for (const [key, value] of Object.entries(input)) {
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }
  }

  return params.length ? '?' + params.join('&') : '';
}
export function webImageUri(path) {
  return urljoin(THETA_RESOURCE_ENDPOINT, path);
}
/**
 * Replace path params insithe `path`
 */

export function formatParamPath(path, params) {
  let parsedPath = path;
  Object.entries(params).forEach(([key, value]) => {
    const regex = new RegExp(`{${key}}`);
    const replacement = typeof value === 'string' || typeof value === 'number' ? value.toString() : '';
    parsedPath = parsedPath.replace(regex, replacement);
  });
  return parsedPath;
}